import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";

import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

import { addIcons } from "@platformscode/core";
import {
  alert02Stroke,
  alertCircleStroke,
  checkmarkCircle02Stroke,
  fileUploadStroke,
  informationCircleStroke,
  multiplicationSignStroke,
} from "@platformscode/icons";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

/*
 * CRA-compatible generated copy of the official
 * Platforms Code stylesheet.
 */
import "./styles/vendor/platformscode-core.css";

import "react-datepicker/dist/react-datepicker.css";
import "./App.css";
import "./responsive.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

/*
 * Register icons required by DGA notifications.
 */
addIcons({
  "alert-02": alert02Stroke,
  "alert-circle": alertCircleStroke,
  "checkmark-circle-02":
    checkmarkCircle02Stroke,
  "information-circle":
    informationCircleStroke,
  "multiplication-sign":
    multiplicationSignStroke,
});

/*
 * Global Axios 401 handler.
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("userType");

      if (
        window.location.pathname !==
        "/login"
      ) {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();